import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { Label } from 'ng2-charts';
import { ChartType, ChartDataSets, ChartOptions } from 'chart.js';

@Component({
    selector: 'odl-report-tipo-cliente',
    templateUrl: './report-tipo-cliente.component.html',
    styleUrls: ['./report-tipo-cliente.component.scss']
})
export class ReportTipoClienteComponent implements OnChanges {

    @Input() data:any;

    public tableData:any = {};

    public barChartOptions: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: { xAxes: [{stacked: true}], yAxes: [{stacked: true}] },
    };
    public barChartLabels: Label[] = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartPlugins = [];

    public barChartData: ChartDataSets[] = [
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Sconosciuto', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Privato', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Condominio', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Hotel', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Ditta', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Pubblica amministrazione', type:'bar', stack: 'stackid' },
        { data: [0,0,0,0,0,0,0,0,0,0,0,0],label:'Altro', type:'bar', stack: 'stackid' },
    ];


    public pieChartOptions: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // We use these empty structures as placeholders for dynamic theming.
        // scales: { xAxes: [{stacked: true}], yAxes: [{stacked: true}] },
        /*
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
            }
        }
        */
    };
    public pieChartLabels: Label[] = ['Sconosciuto', 'Privato', 'Condominio', 'Hotel', 'Ditta', 'Pubblica amministrazione', 'Altro'];
    public pieChartType: ChartType = 'pie';
    public pieChartLegend = true;
    public pieChartPlugins = [];

    public pieChartData: ChartDataSets[] = [
        { data: [] }
    ];


    constructor() { }

    ngOnChanges(changes: {[s: string]: SimpleChange}) {
        // console.log('qualcosa è cambiato',changes);
        if ( !changes.data.currentValue ) {
            this.data = {};
        }
        this.setTable();
    }

    setTable() {
        // console.log(this.data);
        this.tableData = {
            totale_mese : [0,0,0,0,0,0,0,0,0,0,0,0],
            totale_anno : 0,
        };
        Object.keys(this.data).forEach( key => {
            this.tableData[key] = this.data[key];
            this.tableData[key].forEach( (val, idx) => {
                this.tableData.totale_mese[idx] += parseInt(val,0);
                this.tableData.totale_anno += parseInt(val,0);
            })
            
        });
        
        this.barChartData[0].data = this.data.unknown || [];            // 0 - Sconosciuto
        this.barChartData[1].data = this.data.clienti_privati || [];    // 1 - Privato
        this.barChartData[2].data = this.data.condomini || [];          // 2 - Condominio
        this.barChartData[3].data = this.data.hotel || [];              // 3 - Hotel
        this.barChartData[4].data = this.data.ditte || [];              // 4 - Ditta
        this.barChartData[5].data = this.data.pubblica_amministrazione || [];   // 5 - Pubblica amministrazione
        this.barChartData[6].data = this.data.altro || [];              // 6 - Altro
        
        this.pieChartData = [
            { data: [
                this.data.unknown ? this.data.unknown.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.clienti_privati ? this.data.clienti_privati.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.condomini ? this.data.condomini.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.hotel ? this.data.hotel.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.ditte ? this.data.ditte.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.pubblica_amministrazione ? this.data.pubblica_amministrazione.reduce( (sum, current) => sum + current, 0) : 0,
                this.data.altro ? this.data.altro.reduce( (sum, current) => sum + current, 0) : 0,
            ] }
        ];
    }

}
